module.exports = __webpack_public_path__ + "static/media/subscriptions-square.ca60cf70.jpg";